const config = {
    apiUrl: import.meta.env.VITE_API_URL,
    appName: import.meta.env.VITE_APP_NAME,
    siteUrl: import.meta.env.VITE_FRONT_END_URL,
    csrfCookieUrl: import.meta.env.VITE_CSRF_COOKIE_URL,
  };
  
  export default config;
